module.exports = __webpack_public_path__ + "static-portal/img/3-1.078b91c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/3-1.jpg
// module id = CLUL
// module chunks = 4